import { render, staticRenderFns } from "./CoursesSingle.vue?vue&type=template&id=06597a32&"
import script from "./CoursesSingle.vue?vue&type=script&lang=js&"
export * from "./CoursesSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports